import axios from 'axios'
import {API_BASE_URL} from '../../../../utils/contants'
import {setupAxios} from './AuthHelpers'
import {UserModel} from './_models'

const API_URL = API_BASE_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/verify_token`
export const LOGIN_URL = `${API_BASE_URL}/auth/login`
export const REGISTER_URL = `${API_URL}/register`
export const REFRESHTOKEN_URL = `${API_URL}/refresh-token`
export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`
export const LOGOUT_URL = `${API_BASE_URL}/auth/logout`
export async function login(email: string, password: string) {
  const res = await fetch(LOGIN_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      // 'X-Tenant-Id': 'tenants',
    },
    body: JSON.stringify({
      email: email,
      password: password,
    }),
  })
  return await res.json()
}
export async function refreshToken() {
  const {token, refreshToken} = setupAxios()
  const res = await fetch(REFRESHTOKEN_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      refreshToken: refreshToken,
    }),
  })
  return await res.json()
}
export async function logoutUser() {
  const {token, id, tenantId} = setupAxios()

  const res = await fetch(LOGOUT_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'X-Tenant-Id': `${tenantId}`,
    },
    body: JSON.stringify({
      id: id,
    }),
  })
  return await res.json()
}
// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    first_name: firstname,
    last_name: lastname,
    password,
    password_confirmation,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    email,
  })
}

export function getUserByToken(token: string) {
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    accessToken: token,
  })
}
